import { useEffect, useMemo, useState } from "react";

import {
  getAllClassesCached,
  getAllClassesCachedSnapshot,
} from "services/classOptionServices";
import type { Class } from "types/Class";

const useAllClasses = () => {
  const initialClasses = useMemo(() => getAllClassesCachedSnapshot(), []);
  const hasInitialClasses = initialClasses.length > 0;
  const [classes, setClasses] = useState<Class[]>(initialClasses);
  const [isLoading, setIsLoading] = useState(!hasInitialClasses);

  useEffect(() => {
    let isMounted = true;

    const fetchClasses = async () => {
      if (!hasInitialClasses) {
        setIsLoading(true);
      }

      try {
        const allClasses = await getAllClassesCached();
        if (!isMounted) return;

        setClasses(allClasses);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchClasses();

    return () => {
      isMounted = false;
    };
  }, [hasInitialClasses]);

  return { classes, isLoading };
};

export default useAllClasses;
